import axios from "axios";
import {REACT_APP_BASE_URL} from "../index";

export const getPrivacyPolicy = () => {
    return axios.get(`${REACT_APP_BASE_URL}/privacy-policy`);
}
